export class Field {
    constructor(field) {
        this.field = field;
        this.key = this.field.find('*[data-key]').data('key');
    }
    loadData() {
    }
    is(value) {
        return this.value === value;
    }
    has(value) {
        return false;
    }
    count() {
        return 0;
    }
}
